var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { loadRuntimeEnv } from './runtimeEnv';
import Store from './store';
function bootstrap() {
    return __awaiter(this, void 0, void 0, function* () {
        yield loadRuntimeEnv();
        // Визуализируем элемент React в корневом узле DOM.
        // Сделаем репозиторий Redux доступным для любого
        // вложенного компонента, которому необходим доступ к репозиторию.
        ReactDOM.render(React.createElement(Provider, { store: Store },
            React.createElement(BrowserRouter, null,
                React.createElement(App, null))), document.getElementById('root'));
    });
}
bootstrap();
